import { throttle } from 'throttle-debounce';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnCurrentTimeChanged = (
    onCurrentTimeChanged: (currentTime: number) => void,
    delay = 0
) => {
    useInstanceEffect(
        (instance) =>
            instance.onCurrentTimeChange(
                delay ? throttle(delay, true, onCurrentTimeChanged) : onCurrentTimeChanged
            ),
        [onCurrentTimeChanged, delay]
    );
};
